import { literal, union } from 'superstruct';
import { createMachine, assign, interpret } from '@xstate/fsm';
import { updateElementTabIndex } from '../a11y-utils';
import { createFocusTrap } from 'focus-trap';
export const DrawerName = union([
    literal('none'),
    literal('browse'),
    literal('cart'),
    literal('menu'),
    literal('search'),
    literal('gift'),
    literal('gift-wrapping')
]);
export const makeOffcanvasMachine = function() {
    return createMachine({
        initial: 'collapsed',
        context: {
            drawerName: 'none',
            element: undefined,
            focusTrap: undefined
        },
        states: {
            collapsed: {
                on: {
                    expand: {
                        target: 'expanded',
                        actions: [
                            assign({
                                drawerName: (_, evt)=>evt.drawerName,
                                element: (_, evt)=>{
                                    const selector = '.js-offcanvas[data-drawer-names="' + evt.drawerName + '"]';
                                    const element = document.querySelector(selector);
                                    return element instanceof HTMLElement ? element : undefined;
                                },
                                focusTrap: (_, evt)=>{
                                    const selector = '.js-offcanvas[data-drawer-names="' + evt.drawerName + '"]';
                                    const element = document.querySelector(selector);
                                    if (element instanceof HTMLElement) {
                                        return createFocusTrap(element, {
                                            onActivate: ()=>console.log('Focus trap activated on:', evt.drawerName),
                                            onDeactivate: ()=>console.log('Focus trap deactivated on:', evt.drawerName),
                                            allowOutsideClick: true
                                        });
                                    }
                                }
                            }),
                            (context)=>{
                                if (context.element && context.focusTrap) {
                                    updateElementTabIndex(context.element, true);
                                    setTimeout(()=>{
                                        var _context_focusTrap;
                                        (_context_focusTrap = context.focusTrap) === null || _context_focusTrap === void 0 ? void 0 : _context_focusTrap.activate();
                                    }, 500);
                                }
                                window.dispatchEvent(new CustomEvent('drawer:expanded', {
                                    detail: {
                                        drawerName: context.drawerName
                                    }
                                }));
                            }
                        ]
                    }
                }
            },
            expanded: {
                on: {
                    collapse: {
                        target: 'collapsed',
                        actions: [
                            (context)=>{
                                if (context.focusTrap) {
                                    context.focusTrap.deactivate();
                                }
                                if (context.element) {
                                    updateElementTabIndex(context.element, false);
                                    context.element.classList.remove('is-expanded');
                                    window.dispatchEvent(new CustomEvent('drawer:collapsed', {
                                        detail: {
                                            drawerName: context.drawerName
                                        }
                                    }));
                                }
                            }
                        ]
                    }
                }
            }
        }
    });
};
export const initOffcanvasMachine = function() {
    return interpret(makeOffcanvasMachine()).start();
};
